// import { useEffect, ReactNode } from "react";
// import Lenis from "lenis";

// interface LenisProviderProps {
//   children: ReactNode;
// }

// const LenisProvider = ({ children }: LenisProviderProps) => {
//   useEffect(() => {
//     const lenis = new Lenis({
//       duration: 1.2, // Animation duration in seconds
//       easing: (t) => Math.min(1, 1.001 - Math.pow(1 - t, 4)), // Easing function
//       smoothWheel: true, // Enable smooth scrolling for wheel events
//       wheelMultiplier: 1, // Sensitivity for wheel
//       touchMultiplier: 2, // Sensitivity for touch
//       infinite: false, // Infinite scrolling
//       orientation: "vertical", // vertical or horizontal
//     });

//     // Animation frame loop with typed time parameter
//     function raf(time: number) {
//       lenis.raf(time);
//       requestAnimationFrame(raf);
//     }

//     requestAnimationFrame(raf);

//     // Cleanup
//     return () => {
//       lenis.destroy();
//     };
//   }, []);

//   return <>{children}</>;
// };

// export default LenisProvider;

// import {
//   useEffect,
//   ReactNode,
//   createContext,
//   useContext,
//   useState,
// } from "react";
// import Lenis from "lenis";

// interface LenisProviderProps {
//   children: ReactNode;
// }

// // Create a context for Lenis
// const LenisContext = createContext<Lenis | null>(null);

// const LenisProvider = ({ children }: LenisProviderProps) => {
//   const [lenis, setLenis] = useState<Lenis | null>(null);

//   useEffect(() => {
//     const lenisInstance = new Lenis({
//       duration: 1.2,
//       easing: (t) => Math.min(1, 1.001 - Math.pow(1 - t, 4)),
//       smoothWheel: true,
//       wheelMultiplier: 1,
//       touchMultiplier: 2,
//       infinite: false,
//       orientation: "vertical",
//     });

//     setLenis(lenisInstance);

//     function raf(time: number) {
//       lenisInstance.raf(time);
//       requestAnimationFrame(raf);
//     }

//     requestAnimationFrame(raf);

//     return () => {
//       lenisInstance.destroy();
//       setLenis(null);
//     };
//   }, []);

//   return (
//     <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>
//   );
// };

// // Custom hook to access Lenis
// export const useLenis = () => useContext(LenisContext);

// export default LenisProvider;

import {
  useEffect,
  ReactNode,
  createContext,
  useContext,
  useState,
} from "react";
import Lenis from "lenis";

interface LenisProviderProps {
  children: ReactNode;
}

// Create a context for Lenis
const LenisContext = createContext<Lenis | null>(null);

const LenisProvider = ({ children }: LenisProviderProps) => {
  const [lenis, setLenis] = useState<Lenis | null>(null);

  useEffect(() => {
    const lenisInstance = new Lenis({
      duration: 1.2,
      easing: (t: number) => Math.min(1, 1.001 - Math.pow(1 - t, 4)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
      orientation: "vertical",
    });

    setLenis(lenisInstance);

    function raf(time: number) {
      lenisInstance.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenisInstance.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>
  );
};

// Custom hook to access Lenis
export const useLenis = () => useContext(LenisContext);

export default LenisProvider;
